module.exports = __webpack_public_path__ + "static/img/banner.35012479.png";